import UtilsFormule from "../../../utils/UtilsFormule";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
const DataTableListCarteCadeauDetails = ({ listCarteCadeaux }) => {
  const navigate = useNavigate();
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);


  const { SearchBar } = Search;

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  function libelleFormatter(cell, row) {
    console.log("row", row);
    return (
      <span>
        {row.ref}-{row.name}
      </span>
    );
  }
  function productFormatter(cell, row) {
    if (row.product != null) {
      return (
        <span>
          {row.product.barcode}-{row.product.name}
        </span>
      );
    } else {
      return <span>Pas de produit</span>;
    }
  }

  function dateCreation(cell, row) {
    return <span>{UtilsFormule.formatDate(row.creationDate)}</span>;
  }

  function isUsed(cell, row) {
    if(cell===0){
      return <span>NON</span>;

    }else{
      return <span>OUI</span>;

    }
  }
  function dateDebut(cell, row) {
    return <span>{UtilsFormule.formatDate(row.dateDebut)}</span>;
  }

  function dateFin(cell, row) {
    return <span>{UtilsFormule.formatDate(row.dateFin)}</span>;
  }

  // Define columns based on available fields
  const columns = [
    {
      dataField: "ref",
      text: "Libellé",
      headerStyle: { width: "20%" },
    },
    {
      dataField: "creationDate",
      text: "Date Création",
      align: "center",
      headerAlign: "center",
      formatter: dateCreation,
      headerStyle: { width: "15%" },
    },
    {
      dataField: "clientName",
      text: "Client",
      headerStyle: { width: "20%" },
    },
    {
      dataField: "isUsed",
      text: "Consommé",
      formatter: isUsed,

      headerStyle: { width: "20%" },
    },
  ];

  // Format Data from provided structure
  const formattedData = listCarteCadeaux.map((item) => ({
    id: item.id,
    ref: item.ref,
    creationDate: item.creationDate,
    clientName: item.client ? `${item.client.firstName} ${item.client.lastName}` : "N/A",
    societeName: item.client?.societe?.title || "N/A",
    isUsed:item.isUsed,
  }));
  return (
    <section class="content">
      <div class="card">
        <div class="card-header  ">
          <h3 class="card-title">Les Cartes Cadeaux </h3>
          <div class="card-tools">
            <button
              type="button"
              class="btn btn-tool"
              data-card-widget="collapse"
              title="Collapse"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="card-body ">
          <ToolkitProvider
            keyField="id"
            data={formattedData}
            columns={columns}
            onTableChange={handleTableChange}
            exportCSV
            search
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                  <div className="ml-auto mr-0">
                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                  </div>
                </div>
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            )}
          </ToolkitProvider>
          {openInfoAlert && (
            <Snackbar
              open={openInfoAlert}
              autoHideDuration={2000}
              onClose={handleInfoClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert variant="filled" onClose={handleInfoClose} severity="info">
                {infoAlertText}
              </Alert>
            </Snackbar>
          )}
        </div>
      </div>
    </section>
  );
};
export default DataTableListCarteCadeauDetails;
